"use strict";
/*
 * Created on 05 24 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutImpactReportDetailRowReleaseDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutImpactReportDetailRowReleaseDTOConverter, _DataObjectConverter_);

  function SelloutImpactReportDetailRowReleaseDTOConverter() {
    _classCallCheck(this, SelloutImpactReportDetailRowReleaseDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailRowReleaseDTOConverter).apply(this, arguments));
  }

  return SelloutImpactReportDetailRowReleaseDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutImpactReportDetailRowReleaseDTOConverter = SelloutImpactReportDetailRowReleaseDTOConverter;